export const BASE_URL = "https://mag.petris.it/api/public/";

export const IMAGE_LABEL_FORMULA_IT =
  "[lotto.codice] - lastra: [image.slab] - [dettaglio.misX]x[dettaglio.misY]x[dettaglio.misZ] - [dettaglio.stato_lavorazione.nome]";

  export const IMAGE_LABEL_FORMULA_EN =
  "[lotto.codice] - slab: [image.slab] - [dettaglio.misX]x[dettaglio.misY]x[dettaglio.misZ] - [dettaglio.stato_lavorazione.nomeEn]";